var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titleFrom',{attrs:{"mode":"edit","isLoading":_vm.isLoading,"item":_vm.item,"permissions":_vm.permissions},on:{"cancel":_vm.cancel,"submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }